import { GLYPH_ICON_OPTIONS } from 'shared/glyphIcons';
import { defaultSearcherItems } from 'shared/searchers';
import { HeroManifest } from '../../types';

const iconOptions = GLYPH_ICON_OPTIONS;

const alignOptions = [
  { value: 'left', label: 'Izquierda' },
  { value: 'center', label: 'Centro' },
  { value: 'right', label: 'Derecha' },
];

export const manifest: HeroManifest = {
  code: 'hero_a',
  label: 'Template 1 · Default',
  fields: [
    { name: 'backgroundImageUrl', label: 'Imagen de fondo', type: 'text', default: '' },
    {
      name: 'mobileBackgroundImageUrl',
      label: 'Imagen responsive (solo móvil)',
      type: 'text',
      default: '',
    },
    {
      name: 'overlay',
      label: 'Oscurecer imagen',
      type: 'range',
      min: 0,
      max: 85,
      step: 1,
      default: 42,
    },
    { name: 'brandColor', label: 'Color principal', type: 'color', default: '#54a5e8' },
    { name: 'brandColor2', label: 'Color secundario', type: 'color', default: '#19a899' },
    { name: 'title', label: 'Título', type: 'textarea', default: 'Explorá. Viví. Recordá.' },
    {
      name: 'description',
      label: 'Descripción',
      type: 'textarea',
      default: 'Destinos únicos, experiencias auténticas.',
    },
    { name: 'titleColor', label: 'Color del título', type: 'color', default: '#ffffff' },
    {
      name: 'descriptionColor',
      label: 'Color de la descripción',
      type: 'color',
      default: '#ffffff',
    },
    { name: 'showCopy', label: 'Mostrar descripción', type: 'boolean', default: true },
    { name: 'showSearchers', label: 'Mostrar buscadores', type: 'boolean', default: true },
    {
      name: 'noSearcherTextAlign',
      label: 'Alineación del texto cuando no hay buscadores',
      type: 'select',
      options: alignOptions,
      default: 'left',
    },
    {
      name: 'searchCardTitle',
      label: 'Título del buscador',
      type: 'text',
      default: 'Encontrá tu próxima experiencia',
    },
    {
      name: 'showSearchCardTitle',
      label: 'Mostrar título del buscador',
      type: 'boolean',
      default: true,
    },
    { name: 'fullBleed', label: 'Imagen hasta el borde superior', type: 'boolean', default: false },
    {
      name: 'benefits',
      label: 'Beneficios',
      type: 'array',
      itemShape: [
        { name: 'icon', label: 'Icono', type: 'select', options: iconOptions, default: 'headset' },
        { name: 'title', label: 'Línea principal', type: 'text', default: '' },
        { name: 'text', label: 'Línea secundaria', type: 'text', default: '' },
        { name: 'show', label: 'Mostrar', type: 'boolean', default: true },
      ],
      default: [
        { icon: 'headset', title: 'Asesoramiento', text: 'Personalizado', show: true },
        { icon: 'award', title: 'Mejores precios', text: 'Garantizados', show: true },
        { icon: 'lock', title: 'Pagos seguros', text: 'Protección de datos', show: true },
        { icon: 'support', title: 'Soporte', text: '24/7', show: true },
      ],
    },
    {
      name: 'searcherTabs',
      label: 'Buscadores (pestañas)',
      type: 'array',
      itemShape: [
        { name: 'id', label: 'Id', type: 'text', default: '' },
        { name: 'url', label: 'URL', type: 'text', default: '' },
        { name: 'show', label: 'Mostrar', type: 'boolean', default: true },
      ],
      default: defaultSearcherItems(),
    },
    { name: 'activeSearcherTabId', label: 'Buscador activo', type: 'text', default: 'paquetes' },
  ],
};
